// The tokens are designed to match with https://github.com/microsoft/fluentui/blob/master/packages/tokens/src/tokens.ts
export const FluentV9ColorTokens = {
    colorNeutralForeground1: '--colorNeutralForeground1',
    colorNeutralForeground1Hover: '--colorNeutralForeground1Hover',
    colorNeutralForeground1Pressed: '--colorNeutralForeground1Pressed',
    colorNeutralForeground1Selected: '--colorNeutralForeground1Selected',
    colorNeutralForeground2: '--colorNeutralForeground2',
    colorNeutralForeground2Hover: '--colorNeutralForeground2Hover',
    colorNeutralForeground2Pressed: '--colorNeutralForeground2Pressed',
    colorNeutralForeground2Selected: '--colorNeutralForeground2Selected',
    colorNeutralForeground2BrandHover: '--colorNeutralForeground2BrandHover',
    colorNeutralForeground2BrandPressed: '--colorNeutralForeground2BrandPressed',
    colorNeutralForeground2BrandSelected: '--colorNeutralForeground2BrandSelected',
    colorNeutralForeground3: '--colorNeutralForeground3',
    colorNeutralForeground3Hover: '--colorNeutralForeground3Hover',
    colorNeutralForeground3Pressed: '--colorNeutralForeground3Pressed',
    colorNeutralForeground3Selected: '--colorNeutralForeground3Selected',
    colorNeutralForeground3BrandHover: '--colorNeutralForeground3BrandHover',
    colorNeutralForeground3BrandPressed: '--colorNeutralForeground3BrandPressed',
    colorNeutralForeground3BrandSelected: '--colorNeutralForeground3BrandSelected',
    colorNeutralForeground4: '--colorNeutralForeground4',
    colorNeutralForegroundDisabled: '--colorNeutralForegroundDisabled',
    colorBrandForegroundLink: '--colorBrandForegroundLink',
    colorBrandForegroundLinkHover: '--colorBrandForegroundLinkHover',
    colorBrandForegroundLinkPressed: '--colorBrandForegroundLinkPressed',
    colorBrandForegroundLinkSelected: '--colorBrandForegroundLinkSelected',
    colorNeutralForeground2Link: '--colorNeutralForeground2Link',
    colorNeutralForeground2LinkHover: '--colorNeutralForeground2LinkHover',
    colorNeutralForeground2LinkPressed: '--colorNeutralForeground2LinkPressed',
    colorNeutralForeground2LinkSelected: '--colorNeutralForeground2LinkSelected',
    colorCompoundBrandForeground1: '--colorCompoundBrandForeground1',
    colorCompoundBrandForeground1Hover: '--colorCompoundBrandForeground1Hover',
    colorCompoundBrandForeground1Pressed: '--colorCompoundBrandForeground1Pressed',
    colorNeutralForegroundOnBrand: '--colorNeutralForegroundOnBrand',
    colorNeutralForegroundInverted: '--colorNeutralForegroundInverted',
    colorNeutralForegroundInvertedHover: '--colorNeutralForegroundInvertedHover',
    colorNeutralForegroundInvertedPressed: '--colorNeutralForegroundInvertedPressed',
    colorNeutralForegroundInvertedSelected: '--colorNeutralForegroundInvertedSelected',
    colorNeutralForegroundInverted2: '--colorNeutralForegroundInverted2',
    colorNeutralForegroundStaticInverted: '--colorNeutralForegroundStaticInverted',
    colorNeutralForegroundInvertedLink: '--colorNeutralForegroundInvertedLink',
    colorNeutralForegroundInvertedLinkHover: '--colorNeutralForegroundInvertedLinkHover',
    colorNeutralForegroundInvertedLinkPressed: '--colorNeutralForegroundInvertedLinkPressed',
    colorNeutralForegroundInvertedLinkSelected: '--colorNeutralForegroundInvertedLinkSelected',
    colorNeutralForegroundInvertedDisabled: '--colorNeutralForegroundInvertedDisabled',
    colorBrandForeground1: '--colorBrandForeground1',
    colorBrandForeground2: '--colorBrandForeground2',
    colorNeutralForeground1Static: '--colorNeutralForeground1Static',
    colorBrandForegroundInverted: '--colorBrandForegroundInverted',
    colorBrandForegroundInvertedHover: '--colorBrandForegroundInvertedHover',
    colorBrandForegroundInvertedPressed: '--colorBrandForegroundInvertedPressed',
    colorBrandForegroundOnLight: '--colorBrandForegroundOnLight',
    colorBrandForegroundOnLightHover: '--colorBrandForegroundOnLightHover',
    colorBrandForegroundOnLightPressed: '--colorBrandForegroundOnLightPressed',
    colorBrandForegroundOnLightSelected: '--colorBrandForegroundOnLightSelected',
    colorNeutralBackground1: '--colorNeutralBackground1',
    colorNeutralBackground1Hover: '--colorNeutralBackground1Hover',
    colorNeutralBackground1Pressed: '--colorNeutralBackground1Pressed',
    colorNeutralBackground1Selected: '--colorNeutralBackground1Selected',
    colorNeutralBackground2: '--colorNeutralBackground2',
    colorNeutralBackground2Hover: '--colorNeutralBackground2Hover',
    colorNeutralBackground2Pressed: '--colorNeutralBackground2Pressed',
    colorNeutralBackground2Selected: '--colorNeutralBackground2Selected',
    colorNeutralBackground3: '--colorNeutralBackground3',
    colorNeutralBackground3Hover: '--colorNeutralBackground3Hover',
    colorNeutralBackground3Pressed: '--colorNeutralBackground3Pressed',
    colorNeutralBackground3Selected: '--colorNeutralBackground3Selected',
    colorNeutralBackground4: '--colorNeutralBackground4',
    colorNeutralBackground4Hover: '--colorNeutralBackground4Hover',
    colorNeutralBackground4Pressed: '--colorNeutralBackground4Pressed',
    colorNeutralBackground4Selected: '--colorNeutralBackground4Selected',
    colorNeutralBackground5: '--colorNeutralBackground5',
    colorNeutralBackground5Hover: '--colorNeutralBackground5Hover',
    colorNeutralBackground5Pressed: '--colorNeutralBackground5Pressed',
    colorNeutralBackground5Selected: '--colorNeutralBackground5Selected',
    colorNeutralBackground6: '--colorNeutralBackground6',
    colorNeutralBackgroundInverted: '--colorNeutralBackgroundInverted',
    colorNeutralBackgroundStatic: '--colorNeutralBackgroundStatic',
    colorSubtleBackground: '--colorSubtleBackground',
    colorSubtleBackgroundHover: '--colorSubtleBackgroundHover',
    colorSubtleBackgroundPressed: '--colorSubtleBackgroundPressed',
    colorSubtleBackgroundSelected: '--colorSubtleBackgroundSelected',
    colorSubtleBackgroundLightAlphaHover: '--colorSubtleBackgroundLightAlphaHover',
    colorSubtleBackgroundLightAlphaPressed: '--colorSubtleBackgroundLightAlphaPressed',
    colorSubtleBackgroundLightAlphaSelected: '--colorSubtleBackgroundLightAlphaSelected',
    colorSubtleBackgroundInverted: '--colorSubtleBackgroundInverted',
    colorSubtleBackgroundInvertedHover: '--colorSubtleBackgroundInvertedHover',
    colorSubtleBackgroundInvertedPressed: '--colorSubtleBackgroundInvertedPressed',
    colorSubtleBackgroundInvertedSelected: '--colorSubtleBackgroundInvertedSelected',
    colorTransparentBackground: '--colorTransparentBackground',
    colorTransparentBackgroundHover: '--colorTransparentBackgroundHover',
    colorTransparentBackgroundPressed: '--colorTransparentBackgroundPressed',
    colorTransparentBackgroundSelected: '--colorTransparentBackgroundSelected',
    colorNeutralBackgroundDisabled: '--colorNeutralBackgroundDisabled',
    colorNeutralBackgroundInvertedDisabled: '--colorNeutralBackgroundInvertedDisabled',
    colorNeutralStencil1: '--colorNeutralStencil1',
    colorNeutralStencil2: '--colorNeutralStencil2',
    colorNeutralStencil1Alpha: '--colorNeutralStencil1Alpha',
    colorNeutralStencil2Alpha: '--colorNeutralStencil2Alpha',
    colorBackgroundOverlay: '--colorBackgroundOverlay',
    colorScrollbarOverlay: '--colorScrollbarOverlay',
    colorBrandBackground: '--colorBrandBackground',
    colorBrandBackgroundHover: '--colorBrandBackgroundHover',
    colorBrandBackgroundPressed: '--colorBrandBackgroundPressed',
    colorBrandBackgroundSelected: '--colorBrandBackgroundSelected',
    colorCompoundBrandBackground: '--colorCompoundBrandBackground',
    colorCompoundBrandBackgroundHover: '--colorCompoundBrandBackgroundHover',
    colorCompoundBrandBackgroundPressed: '--colorCompoundBrandBackgroundPressed',
    colorBrandBackgroundStatic: '--colorBrandBackgroundStatic',
    colorBrandBackground2: '--colorBrandBackground2',
    colorBrandBackgroundInverted: '--colorBrandBackgroundInverted',
    colorBrandBackgroundInvertedHover: '--colorBrandBackgroundInvertedHover',
    colorBrandBackgroundInvertedPressed: '--colorBrandBackgroundInvertedPressed',
    colorBrandBackgroundInvertedSelected: '--colorBrandBackgroundInvertedSelected',
    colorNeutralStrokeAccessible: '--colorNeutralStrokeAccessible',
    colorNeutralStrokeAccessibleHover: '--colorNeutralStrokeAccessibleHover',
    colorNeutralStrokeAccessiblePressed: '--colorNeutralStrokeAccessiblePressed',
    colorNeutralStrokeAccessibleSelected: '--colorNeutralStrokeAccessibleSelected',
    colorNeutralStroke1: '--colorNeutralStroke1',
    colorNeutralStroke1Hover: '--colorNeutralStroke1Hover',
    colorNeutralStroke1Pressed: '--colorNeutralStroke1Pressed',
    colorNeutralStroke1Selected: '--colorNeutralStroke1Selected',
    colorNeutralStroke2: '--colorNeutralStroke2',
    colorNeutralStroke3: '--colorNeutralStroke3',
    colorNeutralStrokeOnBrand: '--colorNeutralStrokeOnBrand',
    colorNeutralStrokeOnBrand2: '--colorNeutralStrokeOnBrand2',
    colorNeutralStrokeOnBrand2Hover: '--colorNeutralStrokeOnBrand2Hover',
    colorNeutralStrokeOnBrand2Pressed: '--colorNeutralStrokeOnBrand2Pressed',
    colorNeutralStrokeOnBrand2Selected: '--colorNeutralStrokeOnBrand2Selected',
    colorBrandStroke1: '--colorBrandStroke1',
    colorBrandStroke2: '--colorBrandStroke2',
    colorCompoundBrandStroke: '--colorCompoundBrandStroke',
    colorCompoundBrandStrokeHover: '--colorCompoundBrandStrokeHover',
    colorCompoundBrandStrokePressed: '--colorCompoundBrandStrokePressed',
    colorNeutralStrokeDisabled: '--colorNeutralStrokeDisabled',
    colorNeutralStrokeInvertedDisabled: '--colorNeutralStrokeInvertedDisabled',
    colorTransparentStroke: '--colorTransparentStroke',
    colorTransparentStrokeInteractive: '--colorTransparentStrokeInteractive',
    colorTransparentStrokeDisabled: '--colorTransparentStrokeDisabled',
    colorStrokeFocus1: '--colorStrokeFocus1',
    colorStrokeFocus2: '--colorStrokeFocus2',
    colorNeutralShadowAmbient: '--colorNeutralShadowAmbient',
    colorNeutralShadowKey: '--colorNeutralShadowKey',
    colorNeutralShadowAmbientLighter: '--colorNeutralShadowAmbientLighter',
    colorNeutralShadowKeyLighter: '--colorNeutralShadowKeyLighter',
    colorNeutralShadowAmbientDarker: '--colorNeutralShadowAmbientDarker',
    colorNeutralShadowKeyDarker: '--colorNeutralShadowKeyDarker',
    colorBrandShadowAmbient: '--colorBrandShadowAmbient',
    colorBrandShadowKey: '--colorBrandShadowKey'
};
export const FluentV9FontFamilyTokens = {
    fontFamilyBase: '--fontFamilyBase',
    fontFamilyMonospace: '--fontFamilyMonospace',
    fontFamilyNumeric: '--fontFamilyNumeric'
};
/**
 * @deprecated Loop components should work across all hosts, so we shouldn't rely on tokens only in Loop App.
 * Introduce or reuse tokens from FluidThemeColorPropertyNames instead.
 */ export const LoopAppCustomTokens = {
    colorNeutralBackground7: '--colorNeutralBackground7',
    colorNeutralBackground7Selected: '--colorNeutralBackground7Selected'
};
